import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './Explain.css';

/**
 * A number (or an ⓘ) that opens a small pop-up saying how it was worked out.
 *
 *   <Explain title="Winning days" body={<p>378 winning days ÷ 410 days …</p>}>92.2%</Explain>
 *   <Explain title="Passed" body={…} icon />   // an ⓘ instead of a value
 */
export default function Explain({ title, body, children, icon = false, className = '' }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <>
      <button
        type="button"
        className={`pfx-trigger${icon ? ' pfx-trigger--icon' : ''} ${className}`.trim()}
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        aria-label={icon ? `How ${title} is worked out` : undefined}
        title="How this was worked out"
      >
        {icon ? 'ⓘ' : children}
      </button>
      {open ? ReactDOM.createPortal(
        <div className="pfx-overlay" role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) setOpen(false); }}>
          <div className="pfx-panel" role="dialog" aria-modal="true" aria-label={title}>
            <div className="pfx-head">
              <h3>{title}</h3>
              <button type="button" className="pfx-close" onClick={() => setOpen(false)} aria-label="Close">×</button>
            </div>
            <div className="pfx-body">{body}</div>
          </div>
        </div>,
        document.body,
      ) : null}
    </>
  );
}
